// Shared, opt-in section families. Generated from the approved 24-family catalogue.
export const PURPOSE_FAMILIES = [
  {
    id: "benefits",
    type: "BenefitsSection",
    title: "Fordele",
    category: "Viden og tryghed",
    description:
      "De vigtigste grunde til at vælge virksomheden. Fordelene redigeres som en enkel liste.",
    variants: ["Ikoner i række", "Rolige kort", "Liste med billede"],
    source: {
      status: "simplify",
      current:
        "Højdepunkter (Hightlights), ContentCardComponent og GridComponent kan allerede vise kort med billede, tekst og link.",
      change:
        "En formålsbestemt Fordele-editor, ikonvalg og samlede layoutvalg. Genbrug kortene; undgå en parallel renderer.",
      templates: ["3box_image_text", "imageleft_icontextright"],
    },
    items: [
      ["Lokalt kendskab", "Vi kender kvartererne og køberne."],
      ["En fast kontakt", "Du ved altid, hvem du skal ringe til."],
      ["En tydelig plan", "Vi aftaler næste skridt sammen."],
    ],
  },
  {
    id: "steps",
    type: "ProcessSection",
    title: "Sådan foregår det",
    category: "Sælg og køb",
    description:
      "Vis et forløb i overskuelige trin. Nummereringen følger automatisk rækkefølgen.",
    variants: ["Trin på række", "Tidslinje", "Trin med billeder"],
    source: {
      status: "new",
      current:
        "Et forløb kan tegnes med tekst og kort. Det gamle Processbånd er markeret som ikke understøttet og kan ikke genbruges sikkert.",
      change:
        "Tilføj en understøttet trinmodel med automatisk nummerering og tidslinje.",
      templates: ["3box_image_text"],
    },
    items: [
      ["Vi mødes", "Vi ser boligen og lytter til dine planer."],
      ["Vi lægger planen", "Pris, præsentation og forløb bliver aftalt."],
      ["Du kommer godt videre", "Vi følger dig frem til nøgleoverdragelsen."],
    ],
  },
  {
    id: "faq",
    type: "FaqSection",
    title: "Spørgsmål og svar",
    category: "Viden og tryghed",
    description:
      "Giv korte svar på kundernes spørgsmål uden lange, tunge tekstsider.",
    variants: ["Fold ud", "To grupper", "Svar ved siden af"],
    source: {
      status: "new",
      current:
        "Ingen understøttet FAQ- eller harmonika-type fundet i den gennemgåede registry og renderer.",
      change:
        "Tilføj strukturerede spørgsmål/svar, tilgængelig fold-ud-adfærd og grupper. Undgå kundespecifik HTML.",
      templates: [],
    },
    items: [
      [
        "Hvad koster en salgsvurdering?",
        "En salgsvurdering er gratis og uforpligtende. Vi aftaler sammen, hvad der skal ske bagefter.",
      ],
      [
        "Hvor lang tid tager et salg?",
        "Det afhænger af boligen og markedet. Vi giver dig et realistisk billede ved vores første møde.",
      ],
      [
        "Skal jeg have fundet min næste bolig?",
        "Nej. Vi kan også hjælpe dig med at planlægge rækkefølgen.",
      ],
    ],
  },
  {
    id: "shortcuts",
    type: "QuickLinksSection",
    title: "Genveje",
    category: "Præsentation",
    description: "Hjælp besøgende direkte videre til det, de leder efter.",
    variants: ["Billedkort", "Kompakte genveje", "Ét stort og to små"],
    source: {
      status: "simplify",
      current:
        "Højdepunkter og ContentCardComponent understøtter allerede billede, tekst og link.",
      change:
        "En genvejs-editor og kuraterede skabeloner med visuel layoutvælger.",
      templates: ["3box_image_text", "4box_image_text"],
    },
    items: [
      ["Sælg din bolig", "Start med en uforpligtende vurdering."],
      ["Find dit næste hjem", "Se mulighederne i dit område."],
      ["Lær os at kende", "Mød dem, der hjælper dig."],
    ],
  },
  {
    id: "cta",
    type: "ContactBandSection",
    title: "Kontaktbånd",
    category: "Kontakt",
    description:
      "Saml én tydelig opfordring, lidt tekst og op til fire knapper.",
    variants: ["Kompakt bånd", "Billede og knap", "Centreret fokus"],
    source: {
      status: "simplify",
      current:
        "ImageCtaSection, CtaComponent og eksisterende billed-/knapskabeloner dækker grundelementerne.",
      change:
        "Saml dem i en enkel Kontaktbånd-editor; genbrug knapper, links og renderer.",
      templates: ["bgimg_2cta_text", "cta_image_left", "cta_image_right"],
    },
    items: [],
  },
  {
    id: "stats",
    type: "StatisticsSection",
    title: "Nøgletal",
    category: "Viden og tryghed",
    description: "Fremhæv få dokumenterede tal med forklaring og kilde.",
    variants: ["Tal i række", "Tal på farvet flade", "Tal med historie"],
    source: {
      status: "simplify",
      current:
        "Tekst, kort og gitter kan vise manuelt indtastede tal. Ingen særskilt Nøgletal-type fundet.",
      change:
        "En lille tal/enhed/forklaring-model med kilde og dato; brug fælles tekst- og kortvisning. Automatiske tal er særskilt scope.",
      templates: [],
    },
    items: [
      ["25", "års lokalt kendskab"],
      ["98 %", "vil anbefale os"],
      ["4,9 / 5", "i kundevurdering"],
    ],
  },
  {
    id: "areas",
    type: "AreaGuideSection",
    title: "Områdeguide",
    category: "Sælg og køb",
    description: "Præsenter kvarterer og områder med ensartede, lette kort.",
    variants: ["Områdekort", "Stor fortælling", "Kompakt oversigt"],
    source: {
      status: "simplify",
      current:
        "Billedkort, Højdepunkter, ContentCardComponent og side-/artikellinks findes.",
      change:
        "Giv kortene en enkel Områdeguide-editor med fakta og destination. Ingen ny geografisk datakilde.",
      templates: ["3box_image_text", "4box_image_text"],
    },
    items: [
      ["Ved vandet", "Lys, luft og stier langs kysten."],
      ["Midt i byen", "Caféer, kultur og hverdag tæt på."],
      ["Tæt på naturen", "Rolige veje med plads til familien."],
    ],
  },
  {
    id: "packages",
    type: "PackagesSection",
    title: "Priser og pakker",
    category: "Sælg og køb",
    description: "Gør ydelser og indhold lette at sammenligne.",
    variants: ["Pakkekort", "Enkel prisliste", "Én fremhævet pakke"],
    source: {
      status: "simplify",
      current:
        "Tekst, kort, gitter og knapper kan allerede danne priskort. Ingen dedikeret pakke-editor fundet.",
      change:
        "En struktureret pakke-editor til pris, ydelser og knap pr. pakke. Del kortvisning med eksisterende komponenter.",
      templates: [],
    },
    items: [
      ["Boligtjek", "Et klart overblik før du beslutter dig."],
      ["Køberrådgivning", "Hjælp fra gennemgang til underskrift."],
      ["Hele vejen", "Et samlet forløb med fast kontakt."],
    ],
  },
  {
    id: "downloads",
    type: "DownloadsSection",
    title: "Dokumenter og guides",
    category: "Indhold",
    description: "Giv brochurer, tjeklister og guides en tydelig plads.",
    variants: ["Dokumentliste", "Guidekort", "Fremhævet guide"],
    source: {
      status: "simplify",
      current:
        "Medier og linkknapper findes. Der er også sagsdokument-download, men det er ikke et generelt guidebibliotek.",
      change:
        "En dokumentliste med filvalg og automatisk filmetadata; genbrug medier og linkhåndtering.",
      templates: [],
    },
    items: [
      ["Klar til at sælge", "Tjekliste · PDF · eksempel"],
      ["Køberens guide", "Overblik · PDF · eksempel"],
      ["Den gode flytning", "Guide · PDF · eksempel"],
    ],
  },
  {
    id: "logos",
    type: "LogoListSection",
    title: "Logoer og mærker",
    category: "Viden og tryghed",
    description:
      "Vis medlemskaber, samarbejdspartnere eller udmærkelser roligt og ensartet.",
    variants: ["Logoer i række", "Logoer i gitter", "Logoer med forklaring"],
    source: {
      status: "simplify",
      current:
        "ImageComponent/GridComponent og automatiske branchelogoer (MembershipLogosComponent) findes allerede.",
      change:
        "Et enkelt frit logo-bibliotek med billedvalg og links. Automatiske medlemslogoer skal fortsat bruge stamdata.",
      templates: ["3_images_per_row", "4_images_per_row"],
    },
    items: [
      ["Medlemskab", "Et fagligt fællesskab"],
      ["Lokal partner", "Samarbejde i dit område"],
      ["Kvalitetsmærke", "Læs, hvad mærket betyder"],
    ],
  },
  {
    id: "compare",
    type: "ComparisonSection",
    title: "Sammenligning",
    category: "Sælg og køb",
    description:
      "Gør forskelle mellem ydelser eller valgmuligheder lette at forstå.",
    variants: ["Sammenligningstabel", "Side om side", "Fremhævet valg"],
    source: {
      status: "new",
      current:
        "Kort og tekst kan efterligne sammenligning visuelt, men en struktureret sammenligningstabel findes ikke.",
      change:
        "Tilføj en fælles rækkemodel, 2–3 valg og tilgængelig tabel-/kortvisning.",
      templates: [],
    },
    items: [
      ["Personlig plan", "Individuelt forløb"],
      ["Fast kontakt", "Den samme rådgiver"],
      ["Opfølgning", "Aftalt efter behov"],
    ],
  },
  {
    id: "event",
    type: "EventSection",
    title: "Arrangement",
    category: "Kontakt",
    description:
      "Invitér til et lokalt arrangement med tydelig tid, sted og tilmelding.",
    variants: ["Invitation med billede", "Dato i fokus", "Kompakt invitation"],
    source: {
      status: "new",
      current:
        "Åbent hus fra sagsdata og almindelige formularer findes; de er ikke en generel arrangementstype.",
      change:
        "Tilføj manuel arrangementdato, tidszone, udløbsadfærd og reference til eksisterende formular. Alle indlejrede formularer får ekstra beskedtekst.",
      templates: [],
    },
    items: [
      ["24", "OKT"],
      ["16.00–18.00", "Kystvej 12"],
      ["Gratis", "Tilmelding via link"],
    ],
  },
  {
    id: "image-text",
    type: "ImageTextBlockSection",
    title: "Medie og tekst",
    category: "Præsentation",
    description:
      "Start en side eller fortæl en historie med et billede eller en video, tekst og op til fire knapper.",
    variants: ["Billede til venstre", "Billede til højre", "Tekst på billede"],
    source: {
      status: "existing",
      current:
        "ImageTextSectionComponent, Foto med tekst og billed-/tekstskabeloner findes.",
      change:
        "Genbrug billede/tekst-typerne og udvid kun manglende layoutkontroller.",
      templates: [
        "cta_image_left",
        "cta_image_right",
        "imageleft_icontextright",
        "full_image_headline",
        "bgimg_2cta_text",
        "simple_image",
      ],
    },
    items: [],
  },
  {
    id: "text",
    type: "TextBlockSection",
    title: "Tekstafsnit",
    category: "Indhold",
    description:
      "Skriv en introduktion eller en længere forklaring med god læsbarhed.",
    variants: ["Smal tekst", "Overskrift ved siden af", "To tekstkolonner"],
    source: {
      status: "existing",
      current:
        "Tekst, TypographyComponent og skabeloner med én/to tekstkolonner findes.",
      change:
        "Giv samme indhold en enkel editor og visuelle layoutvalg; ingen ny tekst-renderer.",
      templates: [
        "simple_text_body",
        "headline_text",
        "text_2columns",
        "headline_text_2columns",
      ],
    },
    items: [],
  },
  {
    id: "form",
    type: "FormIntroSection",
    title: "Formular med intro",
    category: "Kontakt",
    description:
      "Forklar formålet og vis den rigtige formular uden manuelt layoutarbejde.",
    variants: [
      "Intro ved siden af",
      "Intro over formular",
      "Billede og formular",
      "Billede ved siden af",
      "Kun formular",
    ],
    source: {
      status: "existing",
      current:
        "ContactForm, AssessmentForm, WishForm og intro-/formularskabeloner findes. Kontakt og vurdering har allerede messageTextPre/Post.",
      change:
        "Genbrug de rigtige formularer med fuld konfiguration, også med et billede eller en video alene i den ene kolonne og overskrift, tekst og formular på en flade i den anden. Tilføj samme ekstra beskedtekst til WishForm-afsendelsen; undgå de gamle wrappers, som kasserer config.",
      templates: [
        "contact_form",
        "contact_form_text_left",
        "contact_form_text_right",
        "assessment_form",
        "assessment_form_text_left",
        "assessment_form_text_right",
        "wish_form",
      ],
    },
    items: [],
  },
  {
    id: "contact",
    type: "StoreContactSection",
    title: "Kontakt og åbningstider",
    category: "Kontakt",
    description:
      "Vis korrekte kontaktoplysninger samlet og hent dem fra butikken.",
    variants: ["Kort og oplysninger", "Kontaktkort", "Åbningstider i fokus"],
    source: {
      status: "existing",
      current:
        "Kontakt, StoreSectionComponent, Butikspræsentation og automatiske kontakt-/åbningstidselementer findes.",
      change:
        "Genbrug stamdata og redigér kun visning, layout og valg af butik.",
      templates: ["store_information_automatic"],
    },
    items: [],
  },
  {
    id: "video",
    type: "VideoStorySection",
    title: "Video og fortælling",
    category: "Medier",
    description:
      "Præsenter en film med et tydeligt omslag og tilhørende tekst.",
    variants: ["Film ved siden af", "Stor film", "Film med citat"],
    source: {
      status: "existing",
      current: "Video, Video med tekst, CTA og VideoComponent findes.",
      change:
        "Genbrug videokilder/afspiller; tilføj kun manglende citat-, transskriptions- og layoutkontroller.",
      templates: ["video_text_cta_center", "video_text_cta_left"],
    },
    items: [],
  },
  {
    id: "gallery",
    type: "ImageGallerySection",
    title: "Billedgalleri",
    category: "Medier",
    description: "Fortæl med billeder, uden at bygge en mosaik af kolonner.",
    variants: ["Roligt gitter", "Mosaik", "Billedserie"],
    source: {
      status: "existing",
      current:
        "GallerySectionComponent, Fotos og billed-/sliderskabeloner findes.",
      change:
        "Genbrug almindeligt galleri og tilføj kuraterede varianter. Sagens Billedgrid skal fortsat hente sagsbilleder.",
      templates: ["3_images_per_row", "slider_4_images", "mosaik_4x4"],
    },
    items: [],
  },
  {
    id: "person",
    type: "ContactPersonSection",
    title: "Kontaktperson",
    category: "Kontakt",
    description: "Fremhæv én medarbejder, som besøgende kan kontakte direkte.",
    variants: [
      "Portræt ved siden af",
      "Enkelt profilkort",
      "Bred kontaktflade",
      "Tekst ved siden af kortet",
    ],
    source: {
      status: "existing",
      current:
        "EmployeeCardComponent og Medarbejder detaljevisning-skabelonen findes.",
      change:
        "En medarbejdervælger og enklere layout-/feltvalg; samme stamdata og eksisterende profil.",
      templates: ["employee_details"],
    },
    items: [],
  },
  {
    id: "testimonials",
    type: "TestimonialsSection",
    title: "Kundeudtalelser",
    category: "Viden og tryghed",
    description:
      "Vis kundernes oplevelser med de eksisterende udtalelseslayouts.",
    variants: [
      "Citat i fokus",
      "Kort med billeder",
      "Enkel citatkarrusel",
      "Klassiske kort",
    ],
    source: {
      status: "existing",
      current:
        "TestimonySection og TestimonyListComponent med split, billedkort og citatkarrusel findes allerede.",
      change:
        "Genbrug de leverede varianter og forbedr udvælgelse/skabeloner; ingen parallel udtalelsestype.",
      templates: [
        "testimony_list",
        "testimony_split",
        "testimony_image_cards",
        "testimony_quote_carousel",
      ],
    },
    items: [
      ["En tryg oplevelse", "Vi vidste altid, hvad næste skridt var."],
      ["God rådgivning", "Der var tid til vores spørgsmål."],
      ["Hele vejen", "Vi følte os godt hjulpet."],
    ],
  },
  {
    id: "recommendations",
    type: "RecommendationsSection",
    title: "Anbefalinger",
    category: "Viden og tryghed",
    description:
      "Vis anbefalinger, referencer eller projekter som rækker med et billede eller en video ved siden af teksten.",
    variants: ["Rækker", "Rækker i kort"],
    source: {
      status: "new",
      current:
        "Flexbånd »Liste« (FlexSection, FlexSectionRow) på 8 hjemmesider.",
      change:
        "En gen-2 type med rækker, hvor hver række har sit eget medie ved siden af teksten.",
      templates: [],
    },
    items: [
      ["Et trygt salg", "Vi vidste altid, hvad næste skridt var."],
      ["Investeringsejendom i gågaden", "Butik i to plan og to lejligheder."],
      ["Rundvisning i byhuset", "Se huset i en kort film."],
    ],
  },
  {
    id: "team",
    type: "TeamSection",
    title: "Medarbejdere",
    category: "Kontakt",
    description:
      "Præsenter det relevante team med data, der holdes ajour ét sted.",
    variants: [
      "Portrætter i gitter",
      "Kompakt teamliste",
      "Team med introduktion",
    ],
    source: {
      status: "existing",
      current:
        "Medarbejder-sektionen, EmployeeCardComponent og automatisk medarbejderliste findes.",
      change:
        "Genbrug medarbejderdata; tilføj kun manglende udvalg, filtre og kompakte layouts.",
      templates: ["employees_automatic"],
    },
    items: [
      ["Anna Jensen", "Ejendomsmægler"],
      ["Mikkel Holm", "Køberrådgiver"],
      ["Sara Lund", "Sagskoordinator"],
    ],
  },
  {
    id: "articles",
    type: "ArticleListSection",
    title: "Artikler",
    category: "Indhold",
    description: "Gør nyheder, guides og kundehistorier lette at finde.",
    variants: [
      "Redaktionelt udvalg",
      "Seneste artikler",
      "En fremhævet artikel",
    ],
    source: {
      status: "existing",
      current:
        "ArticleComponent og artikelsamlinger med lister, kort og fremhævede artikler findes.",
      change:
        "Genbrug eksisterende publiceringsregler, artikeldestinationer og layoutvarianter.",
      templates: ["blog_collection", "blog_featured", "blog_home", "blog_card"],
    },
    items: [
      ["Boligliv ved kysten", "Inspiration til dit næste kapitel"],
      ["Klar til fremvisning", "Fem små ting, der gør en forskel"],
      ["Et hjem med historie", "Mød menneskerne bag handlen"],
    ],
  },
  {
    id: "property-list",
    type: "PropertyListSection",
    title: "Sagsliste",
    category: "Sælg og køb",
    description:
      "Hele listen over boliger med søgning, filtre, sortering, visninger og kortvisning.",
    variants: ["Værktøjslinje", "Søgepanel", "Liste og kortvisning"],
    source: {
      status: "new",
      current:
        "CaseList (Sagsliste) er den eneste liste med søgning, filtre og sideinddeling.",
      change:
        "En gen-2 sagsliste med granuleret styring; CaseList forbliver uændret.",
      templates: [],
    },
    items: [
      ["Kystvej 12", "Villa · 142 m²"],
      ["Bakkevej 8", "Rækkehus · 118 m²"],
      ["Havnegade 24", "Ejerlejlighed · 96 m²"],
    ],
  },
  {
    id: "manual-listings",
    type: "ManualListingsSection",
    title: "Skuffesager",
    category: "Sælg og køb",
    description:
      "Boliger, der skrives ind i sektionen: skuffesager, kommende salg og diskrete salg – vist med fuld adresse, kun området eller helt anonymt.",
    variants: ["Gitter", "Liste", "Karrusel", "Fremhævet først", "Med kort"],
    source: {
      status: "new",
      current: "Skuffesager findes kun som HTML-kode (egelund, falkehoj).",
      change:
        "En gen-2 type med boliger, man selv skriver ind, og fire niveauer af anonymitet.",
      templates: [],
    },
    items: [
      ["Villa ved Bugten", "Skuffesag · Risskov"],
      ["Penthouse på havnen", "Kommer snart · Aarhus C"],
      ["Landsted med eng og skov", "Diskret salg · Djursland"],
    ],
  },
  {
    id: "properties",
    type: "PropertySelectionSection",
    title: "Ejendomme",
    category: "Sælg og køb",
    description:
      "Fremhæv de rette sager med data fra det eksisterende ejendomssystem.",
    variants: ["Udvalgte ejendomme", "Nye boliger", "Én bolig i fokus"],
    source: {
      status: "existing",
      current:
        "CaseList, Emnevisning, Fokus bolig, FocusEstateComponent og Fokusbånd findes.",
      change:
        "Genbrug sagskilder og filtrering. Kurater skabeloner og kompletter eventuelt manglende CMS-kontroller.",
      templates: [
        "focus_bolig",
        "focus-band",
        "cases_teaser_3columns",
        "cases_sold_list",
      ],
    },
    items: [
      ["Kystvej 12", "Villa · 142 m²"],
      ["Bakkevej 8", "Rækkehus · 118 m²"],
      ["Havnegade 24", "Ejerlejlighed · 96 m²"],
    ],
  },
  {
    id: "embed",
    type: "EmbedSection",
    title: "Indlejret side",
    category: "Medier",
    description:
      "Vis en beregner eller formular fra en godkendt tjeneste direkte på siden.",
    variants: ["Tekst over siden", "Tekst ved siden af"],
    source: {
      status: "new",
      current:
        "Indlejret side i Fri opbygning (IframeComponent) og iframes i HTML-kode.",
      change:
        "En sikker, formålsbestemt type med godkendte tjenester, højde pr. skærm og automatisk højde.",
      templates: [],
    },
    items: [],
  },
  {
    id: "quote-carousel",
    type: "QuoteCarouselSection",
    title: "Citatkarrusel",
    category: "Viden og tryghed",
    description:
      "Lad kundernes og medarbejdernes egne ord skifte på én flade – som stort citat, med portræt, på et billede eller som kort.",
    variants: [
      "Stort citat",
      "Citat med portræt",
      "Citat på billede",
      "Citatkort",
      "Intro ved siden af",
    ],
    source: {
      status: "new",
      current:
        "Kundeudtalelser har en enkel citatkarrusel uden portræt, billede og kort; på PROD findes citater kun i Fri opbygnings »Slider med tekst«.",
      change: "En gen-2 type med fem layouts og den fælles karrusel.",
      templates: [],
    },
    items: [
      [
        "Mette og Lars",
        "Vi følte os trygge hele vejen – fra første snak om prisen til den dag, nøglerne skiftede hænder.",
      ],
      [
        "Birgitte, Rungsted",
        "Hurtig og ærlig rådgivning. Vi kan varmt anbefale jer.",
      ],
      [
        "Familien Krogh",
        "Huset blev solgt på tre uger og til den pris, vi havde håbet på.",
      ],
    ],
  },
  {
    id: "disclosure",
    type: "StoreDisclosureSection",
    title: "Samarbejdsaftaler",
    category: "Viden og tryghed",
    description:
      "Vis butikkens lovpligtige oplysninger om samarbejdspartnere, provision, forsikring og medlemskaber – hentet fra butikkens data.",
    variants: ["Enkel liste", "Tabel", "Afsnit i kort"],
    source: {
      status: "simplify",
      current:
        "Samarbejdsaftale og Komplet samarbejdsaftale; den sidste med faste udsagn om forsikring og medlemskab.",
      change: "Kun butikkens egne data og redaktørens egne tekster.",
      templates: [],
    },
    items: [],
  },
  {
    id: "media-mosaic",
    type: "MediaMosaicSection",
    title: "Mediemosaik",
    category: "Præsentation",
    description:
      "Fliser med billeder eller videoer og tekst og knapper oven på – som områdekort, genveje eller en billedmosaik.",
    variants: ["Gitter", "Stor første flise"],
    source: {
      status: "new",
      current:
        "Fliser med tekst på billedet findes kun i Fri opbygning (Gitter, »Mosaik 4x4«) og som HTML-kode.",
      change:
        "En gen-2 type, hvor teksten altid står på billedet eller videoen, med toning, forløb, tekstfelt og op til fire knapper pr. flise.",
      templates: [],
    },
    items: [
      ["Valby", "Grønne gader tæt på byen"],
      ["Frederiksberg", "Haver, caféer og gode skoler"],
      ["Amager", "Strand og by på én gang"],
    ],
  },
  {
    id: "store-card",
    type: "StoreCardSection",
    title: "Butikskort",
    category: "Kontakt",
    description:
      "Vis butikken som et kort med logo, navn og kontaktoplysninger – hentet fra butikkens data – og en tekst og et billede ved siden af.",
    variants: ["Tekst ved siden af kortet", "Enkelt butikskort"],
    source: {
      status: "new",
      current:
        "Butikspræsentation med en kopi af en medarbejder, der viser firmaet (7 sektioner på 4 hjemmesider).",
      change:
        "En gen-2 type med butikkens logo, navn, kontaktoplysninger og vCard fra butikkens data og en valgfri butik i en kæde.",
      templates: [],
    },
    items: [],
  },
  {
    id: "image-text-advanced",
    type: "ImageTextAdvancedSection",
    title: "Medier og tekst – avanceret",
    category: "Præsentation",
    description:
      "Som Medie og tekst, men billedsiden kan også være en mosaik af billeder eller et gitter med egen inddeling, hvor hvert felt kan skifte mellem flere billeder.",
    variants: ["Billede til venstre", "Billede til højre", "Tekst på billede"],
    source: {
      status: "new",
      current:
        "Billedcollager ved siden af tekst og topbilleder, der toner mellem flere billeder, findes kun i Fri opbygning og som HTML-kode.",
      change:
        "En gen-2 type med alle Medie og tekst's valg og en billedside som mosaik eller gitter med flettede felter og skiftende billeder.",
      templates: [],
    },
    items: [],
  },
  {
    id: "before-after",
    type: "BeforeAfterSection",
    title: "Før og efter",
    category: "Medier",
    description:
      "Vis forskellen med to billeder af samme sted og en skillelinje, den besøgende trækker – fx før og efter en renovering eller boligstyling.",
    variants: ["Stor sammenligning", "Tekst ved siden af", "Flere i gitter"],
    source: {
      status: "new",
      current:
        "Før og efter findes som elementet BeforeAfterComponent i Fri opbygning, kun på hjemmesider med det nye udseende.",
      change:
        "En gen-2 type med op til seks sammenligninger, overskrift, tekst og knapper – kun på hjemmesider med det nye udseende.",
      templates: [],
    },
    items: [],
  },
] as const;
export type PurposeFamilyId = (typeof PURPOSE_FAMILIES)[number]["id"];
export type PurposeSectionType = (typeof PURPOSE_FAMILIES)[number]["type"];
export function purposeFamily(type: string) {
  return PURPOSE_FAMILIES.find((family) => family.type === type);
}
